<template>
    <ul class="pagination justify-content-end ml-auto" style="margin-right: 10px">
        <li v-if="pagination.current_page > 1">
            <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(1)">
                <span aria-hidden="true"><<</span>
            </a>
        </li>
        <li v-if="pagination.current_page > 1">
            <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)">
                <span aria-hidden="true"><</span>
            </a>
        </li>
        <!--:class="{'active': page == pagination.current_page}"-->
        <li v-for="page in pagesNumber" v-bind:key="page" class="done">
            <a href="javascript:void(0)" v-on:click.prevent="changePage(page)" :class="{'active': page == pagination.current_page}">{{ page }}</a>
        </li>
        <li v-if="pagination.current_page < pagination.last_page">
            <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)">
                <span aria-hidden="true">></span>
            </a>
        </li>
        <li v-if="pagination.current_page < pagination.last_page">
            <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.last_page)">
                <span aria-hidden="true">>></span>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "vue-pagination",
        props: {
            pagination: {
                type: Object,
                required: true
            },
            offset: {
                type: Number,
                default: 4
            }
        },
        computed: {
            pagesNumber() {
                if (!this.pagination.to) {
                    return [];
                }
                let from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                let to = from + this.offset * 2;
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                let pagesArray = [];
                for (let page = from; page <= to; page++) {
                    pagesArray.push(page);
                }
                return pagesArray;
            }
        },
        methods: {
            changePage(page) {
                this.pagination.current_page = page;
                this.$emit("paginate");
            }
        }
    };
</script>

<style scoped lang="scss">
    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color 0.3s;
        border: 1px solid #ddd;
        cursor: pointer;
        font-size: 18px;
    }
    .pagination li.done > a.active {
        background-color: #006738;
        color: white;
        border: 1px solid gray;
    }
</style>
